import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'

export const mainSearch = (el) => {
    const closeBtn = el.querySelector('.modal__close')
    const openBtns = document.querySelectorAll('.open-search-form')
    const input = el.querySelector('input')

    document.addEventListener('keydown', (e) => {
        if (!el.hidden && e.key === 'Escape') {
            enableBodyScroll(el)
            el.hidden = true
        }
    })

    if (openBtns?.length) {
        openBtns.forEach(btn => {
            btn.addEventListener('click', () => {
                disableBodyScroll(el)
                el.hidden = false
                if (input) {
                    input.focus()
                }
            })
        })
    }
    if (closeBtn) {
        closeBtn.addEventListener('click', () => {
            enableBodyScroll(el)
            el.hidden = true
        })
    }
}